var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('populate-form',{ref:"merchantInfoForm",attrs:{"formTitle":"供應商資訊","fkey":"mi01","populateOptionVar":"merchantFormItems","formDataObjVar":"FocusedMerchant","validatePrompt":false,"parentVue":this}})}
var staticRenderFns = []

export { render, staticRenderFns }